<template>
  <div>
    <b-modal
      @shown="focusInput"
      ref="modal"
      :title="title"
      header-class="border-bottom-0"
      size="xl"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <new-product-alert />
          </div>
        </div>
        <template>
          <h5 class="text-primary">
            <i class="fas fa-address-card mr-2" />Dados do Produto
          </h5>
        </template>
        <!-- <template v-if="this.sku.value != null">
              <div class="row">
                <div class="col-12">
                  <b-alert show dismissible variant="success" role="alert"
                    >Ultimo Produto Cadastrado Código: {{ this.sku.value }} '{{
                      this.product_name.value
                    }}''</b-alert
                  >
                </div>
              </div>
            </template> -->

        <div class="row">
          <div class="col-md-6">
            <text-input
              ref="description"
              v-model="form.description.value"
              :form="form"
              :name="'description'"
              :alias="form.description.alias"
            />
          </div>
          <div class="col-md-3">
            <template v-if="!form.id.value">
              <number-input
                v-model="form.base_sku_id.value"
                decimalPlaces="0"
                :defaultValueOverride="null"
                :emptyInputBehavior="'null'"
                :alias="form.base_sku_id.alias"
                :disabled="isSkuDisable"
                :formGroupClass="'mb-1'"
              />
              <b-form-checkbox
                inline
                style="margin-right: 10px"
                v-model="form.autoBaseSkuId.value"
                :value="1"
                :unchecked-value="0"
              >
                <small style="cursor: pointer">{{ autoBaseSkuIdText }}</small>
              </b-form-checkbox>
            </template>
            <template v-else>
              <number-input
                :formGroupClass="'mb-1'"
                v-model="form.base_sku_id.value"
                decimalPlaces="0"
                :defaultValueOverride="null"
                :emptyInputBehavior="'null'"
                :alias="form.base_sku_id.alias"
              />
            </template>
          </div>
          <div class="col-md-3">
            <text-input
              v-if="noGtin"
              :formGroupClass="'mb-1'"
              :value="'SEM GTIN'"
              :alias="form.gtin.alias"
              :disabled="true"
            />
            <text-input
              v-else
              :formGroupClass="'mb-1'"
              v-model="form.gtin.value"
              :alias="form.gtin.alias"
            />
            <b-form-checkbox
              inline
              style="margin-right: 10px"
              v-model="form.no_gtin.value"
              :value="1"
              :unchecked-value="0"
            >
              <small style="cursor: pointer">Produto Sem GTIN</small>
            </b-form-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <select-category
              :alias="form.category_id.alias"
              v-model="form.category_id.value"
              :displayedValue="form.category.value"
              :form="form"
              :name="'category_id'"
              @search="searchCategory($event)"
              :searchResult="searchCategoryResults"
              :isLoading="searchCategoryLoading"
              @selected="setCategory($event)"
            >
              <search-input-option
                v-for="(row, index) in searchCategoryResults.data"
                :key="index"
                :index="index"
                @click="setCategory(row)"
              >
                <div>
                  {{ row.description }}
                  <br />
                </div>
              </search-input-option>
            </select-category>
          </div>
          <div class="col-md-4">
            <text-input v-model="form.brand.value" :alias="form.brand.alias" />
          </div>
          <div class="col-md-4">
            <text-input
              v-model="form.manufacturer.value"
              :alias="form.manufacturer.alias"
            />
          </div>
        </div>
        <!-- Com preços iguais a vista -->
        <template v-if="this.$store.state.company.product_payment_policy == 1">
          <div class="row">
            <!-- Preço de Custo -->
            <div class="col-md-4">
              <number-input
                v-model="form.cost.value"
                :alias="form.cost.alias"
              />
            </div>

            <!-- Markup -->
            <div class="col-md-4">
              <number-input
                v-model="form.markup.value"
                @keyup="calcPrice()"
                :alias="form.markup.alias"
                :currencySymbol="' %'"
              />
            </div>
            <!-- Somente preço a vista -->
            <div class="col-md-4">
              <number-input
                v-model="form.price.value"
                @keyup="calcMarkupCashPrice()"
                :alias="form.price.alias"
              />
            </div>
          </div>
        </template>
        <!-- Preço a prazo diferente do preço a vista -->
        <template v-else>
          <div class="row">
            <div class="col-md-2">
              <number-input
                v-model="form.cost.value"
                :alias="form.cost.alias"
              />
            </div>
            <!-- Markup -->
            <div class="col-md-2 ">
              <number-input
                v-model="form.markup.value"
                @keyup="calcPriceImediate(), calcPriceOnTerms()"
                :alias="form.markup.alias"
                :currencySymbol="' %'"
              />
            </div>
            <!-- Preço a vista -->
            <div class="col-md-3">
              <number-input
                v-model="form.company_price_payment_immediate.value"
                @keyup="calcMarkupIfDifferentForwardPrice(), calcPriceOnTerms()"
                :alias="form.company_price_payment_immediate.alias"
              />
            </div>
            <!-- Acréscimo no markup para preço a prazo -->
            <div class="col-md-2">
              <number-input
                v-model="form.term_addition.value"
                @keyup="calcPriceOnTerms()"
                :alias="form.term_addition.alias"
                :currencySymbol="' %'"
              />
            </div>

            <!-- Preço a prazo -->
            <div class="col-md-3">
              <number-input
                v-model="form.company_price_payment_on_terms.value"
                @keyup="calcTermAddition()"
                :alias="form.company_price_payment_on_terms.alias"
              />
            </div>
          </div>
        </template>
        <div class="row">
          <div class="col-md-4">
            <number-input
              v-model="form.comission_rate.value"
              :alias="form.comission_rate.alias"
              :currencySymbol="' %'"
            />
          </div>
          <div class="col-md-4">
            <date-input
              alias="Validade"
              v-model="form.expiration_date.value"
            ></date-input>
          </div>
        </div>
        <template
          v-if="
            this.title == 'Novo produto' &&
              this.$store.state.company.module_stock_active == 1
          "
        >
          <div class="row">
            <div class="col-md-3">
              <h5 class="text-primary"><i class="fas fa-cubes" /> Estoque</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <number-input
                v-model="form.fisic_stock.value"
                :alias="form.fisic_stock.alias"
                :decimalPlaces="3"
              />
            </div>
            <div class="col-md-4">
              <number-input
                v-model="form.minimum_stock.value"
                :alias="form.minimum_stock.alias"
                :decimalPlaces="3"
              />
            </div>
          </div>
        </template>
        <div
          class="row"
          v-if="
            this.title != 'Novo produto' &&
              this.$store.state.company.module_stock_active == 1
          "
        >
          <div class="col-md-4">
            <number-input
              v-model="form.minimum_stock.value"
              :alias="form.minimum_stock.alias"
              :decimalPlaces="3"
            />
          </div>
        </div>
        <br />
        <!-- Informações -->
        <hr />
        <template>
          <h5 class="text-primary">
            <i class="fas fa-box mr-2" /> Informações
          </h5>
        </template>
        <div class="row">
          <div class="col-md-3">
            <number-input
              v-model="form.weight_net.value"
              :alias="form.weight_net.alias"
            />
          </div>
          <div class="col-md-3">
            <number-input
              v-model="form.weight_gross.value"
              :alias="form.weight_gross.alias"
            />
          </div>
          <div class="col-md-2">
            <number-input
              v-model="form.width.value"
              :alias="form.width.alias"
            />
          </div>
          <div class="col-md-2">
            <number-input
              v-model="form.height.value"
              :alias="form.height.alias"
            />
          </div>
          <div class="col-md-2">
            <number-input
              v-model="form.length.value"
              :alias="form.length.alias"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <text-input
              v-model="form.image_url.value"
              :alias="'Url de Imagem'"
              maxlength="1000"
            />
          </div>
        </div>
        <br />

        <!-- DADOS FISCAIS -->
        <hr />
        <template>
          <h5 class="text-primary">
            <i class="fas fa-file-invoice mr-2" />Dados Fiscais
          </h5>
        </template>
        <div class="row">
          <div class="col-md-2">
            <text-input
              :maxlength="2"
              v-model="form.unit.value"
              :alias="form.unit.alias"
            />
          </div>

          <div class="col-md-3">
            <text-input v-model="form.ncm.value" :alias="form.ncm.alias" />
          </div>
          <div class="col-md-3">
            <text-input v-model="form.cest.value" :alias="form.cest.alias" />
          </div>
          <div class="col-md-4">
            <select-input
              v-model="form.csosn.value"
              :alias="form.csosn.alias"
              :options="form.csosn.options"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <select-input
              v-model="form.origem.value"
              :alias="form.origem.alias"
              :options="form.origem.options"
            />
          </div>

          <div class="col-md-6">
            <select-input
              v-model="form.classificacao_fiscal.value"
              :alias="form.classificacao_fiscal.alias"
              :options="form.classificacao_fiscal.options"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <span class="text-primary d-inline">
              <i class="fas fa-search-dollar" /> IBPT
            </span>
            <small class="text-muted"
              >Valor aproximado de tributos pago pelo consumidor</small
            >
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <button
                  role="button"
                  class="btn btn-sm btn-primary"
                  style="margin-left: 5px"
                  @click="getIbpt"
                  :disabled="loadingIbpt"
                >
                  <i :class="['fas fa-sync', { 'fa-spin': loadingIbpt }]"></i>
                  Atualizar IBPT
                </button>
              </div>
              <template v-if="hasIbpt">
                <div class="col-md-4 align-items-end">
                  <small>Valor aproximado dos tributos:</small>&nbsp;
                  <b>{{ sumIbpt | decimal }}</b>
                  <br />
                  <small
                    >Vigencia: {{ this.form.ibpt_vigencia_fim.value }}</small
                  >
                </div>
              </template>
              <template v-else></template>
            </div>
            <error-handler :error="ibptError" />
          </div>
        </div>
        <br />

        <!-- OBSERVAÇÕES -->
        <hr />
        <template>
          <h5 class="text-primary">
            <i class="fas fa-info mr-2" />Observações
          </h5>
        </template>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <textarea
                v-model="form.notes.value"
                placeholder="Digite aqui as Observações sobre o produto"
                maxlength="500"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>

        <!-- Tatamento de erro -->
        <error-handler :error="error" />
        <b-alert
          :show="alertData.isVisible"
          fade
          variant="danger"
          @dismissed="alertData.isVisible = false"
          dismissible
          >{{ alertData.message }}</b-alert
        >

        <!-- form  -->
      </div>
      <br />
      <div class="row">
        <div class="ml-3 d-flex flex-column">
          <h5 class="text-primary">
            Status do Produto
          </h5>
          <div class="col-md-1">
            <b-form-group>
              <b-form-checkbox
                inline
                switch
                style="margin-right: 10px"
                v-model="form.status.value"
                :value="1"
                :unchecked-value="0"
              >
                <!--   d d-->
                <span style="cursor: pointer">
                  <span v-if="form.status.value == 1">Ativo</span>
                  <span v-else>Inativo</span>
                </span>
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
        <div class="ml-4  ">
          <h5 class="text-primary">
            Vender abaixo do estoque?
          </h5>
          <div class="col-md-1">
            <b-form-group>
              <b-form-checkbox
                inline
                switch
                style="margin-right: 10px"
                v-model="form.can_sell_below_stock.value"
                :value="1"
                :unchecked-value="0"
              >
                <!--   d d-->
                <span style="cursor: pointer">
                  <span v-if="form.status.value == 1">Ativo</span>
                  <span v-else>Inativo</span>
                </span>
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
      </div>

      <div
        class="container-fluid d-flex justify-content-between"
        slot="modal-footer"
      >
        <div>
          <b-checkbox
            tabindex="-1"
            switch
            v-model="enablesequential.value"
            :value="1"
            >Adicionar produto em sequência</b-checkbox
          >
        </div>
        <div>
          <button
            role="button"
            class="btn btn-outline-secondary"
            @click="$refs.modal.hide()"
            tabindex="-1"
          >
            <i class="fas fa-times"></i> Cancelar
          </button>
          <button
            role="button"
            class="btn btn-success ml-2"
            style="margin-left: 5px"
            @click="store"
          >
            <i class="fas fa-check"></i> Salvar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Form from "./../../../mixins/Form";
import newProductAlert from "@/components/product/sections/NewProductAlert";
import selectCategory from "../../category/dialogs/SelectCategory";

export default {
  components: {
    newProductAlert,
    selectCategory
  },

  data: function() {
    return {
      id: null,

      form: new Form({
        id: {
          value: null
        },

        // ??
        classification_id: {
          alias: "classification_id"
        },

        description: {
          alias: "Descrição",
          validate: {
            required: true
          }
        },

        base_sku_id: {
          alias: "Código (SKU)"
        },

        autoBaseSkuId: {
          default: 1
        },

        gtin: {
          alias: "Código de barras (GTIN)"
        },

        no_gtin: {
          default: 0
        },
        can_sell_below_stock: {
          default: 0
        },

        category: {
          value: {}
        },

        category_id: {
          alias: "Categoria"
        },

        comission_rate: {
          value: 0,
          alias: "Comissão"
        },

        expiration_date: {
          alias: "Validade"
        },

        brand: {
          alias: "Marca"
        },

        manufacturer: {
          alias: "Fabricante"
        },

        shop_is_published: {
          default: 1
        },

        weight_net: {
          alias: "Peso Líquido (Kg)"
        },

        weight_gross: {
          alias: "Peso Bruto (Kg)"
        },

        width: {
          alias: "Largura (cm)"
        },

        height: {
          alias: "Altura (cm)"
        },

        length: {
          alias: "Comprimento (cm)"
        },

        unit: {
          alias: "Unidade Tributavel"
        },

        ncm: {
          alias: "NCM"
        },

        cest: {
          alias: "CEST"
        },
        csosn: {
          alias: "CSOSN",
          options: {
            "": "",
            101: "  101 | Tributada pelo Simples Nacional com permissão de crédito",
            102: "  102 | Tributada pelo Simples Nacional sem permissão de crédito",
            103: "  103 | Isenção do ICMS no Simples Nacional para faixa de receita bruta",
            201: "  201 | Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária",
            202: "  202 | Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária",
            203: "  203 | Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária",
            300: "  300 | Imune",
            400: "  400 | Não tributada pelo Simples Nacional",
            500: "  500 | ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação",
            900: "  900 | Outros"
          }
        },
        origem: {
          value: "",
          alias: "Origem",
          options: {
            "": "",
            0: " 0 | Nacional, exceto as indicadas nos códigos 3 a 5",
            1: " 1 | Estrangeira - Importação direta, exceto a indicada no código 6",
            2: " 2 | Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7",
            3: " 3 | Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% e inferior ou igual a 70%",
            4: " 4 | Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam as legislações citadas nos Ajustes",
            5: " 5 | Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%",
            6: " 6 | Estrangeira - Importação direta, sem similar nacional, constante em lista da CAMEX",
            7: " 7 | Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista da CAMEX",
            8: " 8 | Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%"
          }
        },
        classificacao_fiscal: {
          alias: "Classificação Fiscal",
          options: {
            null: null,
            "00": "00 | Mercadoria para Revenda",
            "01": "01 | Matéria-Prima",
            "02": "02 | Embalagem",
            "03": "03 | Produto em Processo",
            "04": "04 | Produto Acabado",
            "05": "05 | Subproduto",
            "06": "06 | Produto Intermediário",
            "07": "07 | Material de Uso e Consumo",
            "08": "08 | Ativo Imobilizado",
            "09": "09 | Serviços",
            10: "10 | Outros insumos",
            99: "99 | Outras"
          }
        },

        cost: {
          value: 0,
          alias: "Custo"
        },
        price: {
          value: 0,
          alias: "Preço"
        },

        markup: {
          value: 0,
          alias: "Markup"
        },

        term_addition: {
          value: 0,
          alias: "Adicional a prazo"
        },
        company_price_payment_immediate: {
          value: 0,
          alias: "Preço á vista"
        },

        company_price_payment_on_terms: {
          value: 0,
          alias: "Preço á prazo"
        },

        fisic_stock: {
          alias: "Estoque Inicial"
        },

        minimum_stock: {
          alias: "Estoque Minimo"
        },

        notes: {},
        status: {
          default: 1,
          alias: "status",
          validate: {
            required: true
          }
        },

        image_url: {},

        ibpt_description: {},
        ibpt_nacional: {},
        ibpt_estadual: {},
        ibpt_municipal: {},
        ibpt_importado: {},
        aliquota_ibpt_municipal: {},
        aliquota_ibpt_estadual: {},
        aliquota_ibpt_nacional: {},
        aliquota_ibpt_importado: {},
        ibpt_fonte: {},
        ibpt_vigencia_inicio: {},
        ibpt_vigencia_fim: {}
      }),

      sku: {
        value: null
      },

      product_name: {
        Value: null
      },
      product_variant: [
        {
          product_company: []
        }
      ],
      enablesequential: {
        value: 0
      },

      searchCategoryResults: {},

      searchCategoryLoading: false,

      loadingIbpt: false,

      title: "Novo Produto",

      error: null,

      ibptError: null,

      alertData: {
        isVisible: false,
        message: null
      }
    };
  },

  watch: {
    noGtin() {
      if (this.noGtin) {
        this.form.gtin.value = null;
      }
    },

    autoBaseSkuId(val) {
      if (val == 1) {
        this.form.base_sku_id.value = "";
      }
    }
  },

  computed: {
    autoBaseSkuIdText() {
      if (!this.form.id.value) {
        return "Gerar Código automaticamente";
      } else {
        return "Alterar Código";
      }
    },

    autoBaseSkuId() {
      return this.form.autoBaseSkuId.value;
    },

    noGtin() {
      return this.form.no_gtin.value == 1;
    },

    isSkuDisable() {
      return this.form.autoBaseSkuId.value == 1;
    },

    hasIbpt() {
      return this.form.ibpt_fonte.value;
    },

    sumIbpt() {
      if (this.hasIbpt) {
        return (
          parseFloat(this.form.ibpt_importado.value) +
          parseFloat(this.form.ibpt_municipal.value) +
          parseFloat(this.form.ibpt_estadual.value) +
          parseFloat(this.form.ibpt_nacional.value)
        );
      }
    },

    product() {
      return this.$store.state.products.product;
    },

    ibpt() {
      return this.$store.state.products.ibpt;
    },

    isInsert() {
      return this.id == null;
    },

    successMessage() {
      if (this.isInsert) {
        return "Produto adicionado com sucesso!";
      } else {
        return "Produto atualizado com sucesso!";
      }
    }
  },

  methods: {
    open(id = null, data) {
      this.resetForm();

      this.id = id;

      if (!this.isInsert) {
        this.title = "Atualizar produto";

        this.selectProduct(id);

        this.form.autoBaseSkuId.value = 0;

        return;
      }

      if (data) {
        this.form.setValues(data);
      }

      this.title = "Novo produto";

      this.$refs.modal.show();
    },

    async selectProduct(id) {
      let data = await this.$store.dispatch("products/getProductLegacy", id);

      this.form.setValues(data);

      this.$refs.modal.show();
    },

    addictionSequential() {
      if (this.enablesequential.value == 1) {
        this.resetForm();

        this.focusInput();
      } else {
        this.$refs.modal.hide();
      }
    },

    focusInput() {
      this.$refs.description.setFocus();
    },

    store() {
      if (this.form.isValid()) {
        this.$store.commit("showLoading");

        this.$store
          .dispatch("products/storeProduct", {
            id: this.form.id.value,
            form: this.form.getValues()
          })
          .then(response => {
            this.addictionSequential();

            this.processNewProduct(response.data);

            this.$emit("stored", response.data);

            //this.$emit("saved", this.sku.value);

            this.$store.commit("showAlert", {
              message: this.successMessage,
              type: "success"
            });

            this.$store.commit("hideLoading");
          })
          .catch(error => {
            this.error = error;

            this.$store.commit("hideLoading");
          });
      } else {
        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;
      }
    },

    getIbpt(id) {
      this.ibptError = null;
      this.loadingIbpt = true;
      this.$store
        .dispatch("products/getIbpt", this.form.getValues())
        .then(response => {
          this.form.ibpt = this.ibpt;
          this.form.ibpt_description.value = this.ibpt.Descricao;
          this.form.ibpt_municipal.value = this.ibpt.ValorTributoMunicipal;
          this.form.ibpt_estadual.value = this.ibpt.ValorTributoEstadual;
          this.form.ibpt_nacional.value = this.ibpt.ValorTributoNacional;
          this.form.ibpt_importado.value = this.ibpt.ValorTributoImportado;
          this.form.aliquota_ibpt_municipal.value = this.ibpt.Municipal;
          this.form.aliquota_ibpt_estadual.value = this.ibpt.Estadual;
          this.form.aliquota_ibpt_nacional.value = this.ibpt.Nacional;
          this.form.aliquota_ibpt_importado.value = this.ibpt.Importado;
          this.form.ibpt_fonte.value = this.ibpt.Fonte;
          this.form.ibpt_vigencia_fim.value = this.ibpt.VigenciaFim;
          this.form.ibpt_vigencia_inicio.value = this.formatDate(
            this.ibpt.VigenciaInicio
          );

          this.loadingIbpt = false;
        })
        .catch(error => {
          this.ibptError = error;
          this.loadingIbpt = false;
        });
    },

    formatDate(date) {
      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    },

    resetForm() {
      (this.id = null), (this.error = null);

      this.alertData.isVisible = false;

      this.form.reset();
    },

    searchCategory(search) {
      this.searchCategoryLoading = true;

      axios
        .post(
          process.env.BASE_URL +
            "api/product/category/select?page=" +
            search.page,
          {
            description: search.text,
            status: 1
          }
        )
        .then(response => {
          this.searchCategoryResults = response.data;

          console.log(this.searchCategoryResults);

          this.searchCategoryLoading = false;
        })
        .catch(error => {
          this.error = error;
        });
    },

    setCategory(category) {
      console.log("category", category);
      this.form.category_id.value = category.id;

      this.form.category.value = category.description;
    },

    processNewProduct(newProduct) {
      if (this.isInsert) {
        this.$store.commit("products/setNewProduct", newProduct);
      }
    },
    calcMarkupCashPrice() {
      if (this.form.cost.value > 0 && this.form.price.value > 0) {
        return (this.form.markup.value =
          (this.form.price.value / this.form.cost.value - 1) * 100);
      }
    },

    // calcMarkupIfDifferentForwardPrice
    calcMarkupIfDifferentForwardPrice() {
      if (
        this.form.cost.value > 0 &&
        this.form.company_price_payment_immediate.value > 0
      ) {
        return (this.form.markup.value =
          (this.form.company_price_payment_immediate.value /
            this.form.cost.value -
            1) *
          100);
      }
    },

    calcPrice() {
      if (this.form.cost.value != 0) {
        return (this.form.price.value =
          this.form.cost.value +
          (this.form.cost.value * this.form.markup.value) / 100);
      }
    },

    calcPriceImediate() {
      if (this.form.cost.value != 0) {
        return (this.form.company_price_payment_immediate.value =
          this.form.cost.value +
          (this.form.cost.value * this.form.markup.value) / 100);
      }
    },

    calcPriceOnTerms() {
      if (this.form.term_addition.value >= 0) {
        return (this.form.company_price_payment_on_terms.value =
          this.form.company_price_payment_immediate.value +
          (this.form.company_price_payment_immediate.value *
            this.form.term_addition.value) /
            100);
      }
    },

    calcTermAddition() {
      if (this.form.company_price_payment_on_terms.value > 0) {
        return (this.form.term_addition.value =
          (this.form.company_price_payment_on_terms.value /
            this.form.company_price_payment_immediate.value -
            1) *
          100);
      }
    }
  }
};
</script>
